import React, { useState, useRef, useEffect } from "react";
import { Download, FileText, Table, Loader2 } from "lucide-react";

interface Props {
  onExportCSV: () => void;
  onExportPDF: () => void;
  exporting: boolean;
}

const ExportMenu: React.FC<Props> = ({ onExportCSV, onExportPDF, exporting }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fn = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(o => !o)}
        disabled={exporting}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border
          bg-white text-slate-600 border-slate-200 hover:border-blue-300 hover:text-blue-700
          transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {exporting
          ? <Loader2 size={12} className="animate-spin" />
          : <Download size={12} />
        }
        Exporter
      </button>

      {open && !exporting && (
        <div className="absolute right-0 top-full mt-1.5 w-44 bg-white rounded-xl border border-slate-100
          shadow-lg shadow-slate-200/60 z-50 overflow-hidden animate-[fadeIn_0.15s_ease]">
          <button
            onClick={() => { onExportCSV(); setOpen(false); }}
            className="w-full flex items-center gap-2.5 px-4 py-2.5 text-xs font-medium text-slate-700
              hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <Table size={13} className="text-emerald-500" />
            Exporter CSV
          </button>
          <div className="mx-3 border-t border-slate-50" />
          <button
            onClick={() => { onExportPDF(); setOpen(false); }}
            className="w-full flex items-center gap-2.5 px-4 py-2.5 text-xs font-medium text-slate-700
              hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <FileText size={13} className="text-rose-500" />
            Exporter PDF
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportMenu;